import { useMemo } from 'react';
import { 
	selectDilDefinitionByName
	, DILProperty
	, DIL
	, PropertyType
	, DILPropertyList
	, PropertyFlag
 } from 'srs-middleware';

export function getPropertiesOfType(DIL: DIL | string, type: PropertyType) {
	const properties: DILPropertyList = getPropertyListFromDil(DIL);
	return Object.values(properties).filter(property => property.type === type);
}

// Given an array of types, returns an array of properties that have 1 or more of those types
export function getPropertiesOfTypes(DIL: DIL | string, types: PropertyType[]) {
	const properties: DILPropertyList = getPropertyListFromDil(DIL);
	return Object.values(properties).filter(property => types.includes(property.type));
}

// Given a flag, returns an array of properties that have that flag
export function getPropertiesWithFlag(DIL: DIL | string, flag: PropertyFlag) {
	const properties: DILPropertyList = getPropertyListFromDil(DIL);
	return Object.values(properties).filter(property => property.flags.includes(flag));
}

// TODO: move to srs-client-middleware
// return all of the properties
export function getAllProperties(DIL: DIL | string) {
	if (typeof DIL === 'string') DIL = selectDilDefinitionByName(DIL);
	return Object.values(DIL.propertyList);
}

export const filterProperties = (selectedDefinitionName: string
	, flags: PropertyFlag[] = []
	, types: PropertyType[] = []
	, allowedProperties: String[] = []
	, outFlags: PropertyFlag[] = []
	, outTypes: PropertyType[] = []
	): DILProperty[] => {

	const allProperties: DILProperty[] = Object.values(selectDilDefinitionByName(selectedDefinitionName).propertyList);

	if (allowedProperties.length > 0) {
		return allProperties.filter(prop => {
			return allowedProperties.includes(prop.name)
		})
	} 
	

	const flagged: DILProperty[] =
		flags.length === 0
			? allProperties
			: allProperties.filter(property => {
					return flags.some(flag => {
						return property.flags.includes(flag);
					});
			  });

	const outFlagged: DILProperty[] =
		outFlags.length === 0
			? flagged
			: flagged.filter(property => {
					return outFlags.every(flag => {
						return !property.flags.includes(flag);
					});
			  });

	const typed: DILProperty[] =
		types.length === 0
			? outFlagged
			: outFlagged.filter(property => {
					return types.some(type => {
						return property.type === type;
					});
			  });

	return outTypes.length === 0
		? typed
		: typed.filter(property => {
				return outTypes.every(type => {
					return !(property.type === type)
				});
		  });
};

export const useFilteredProperties = (selectedDefinitionName: string
	, flags: PropertyFlag[] = []
	, types: PropertyType[] = []
	, allowedProperties: String[] = []
	, outFlags: PropertyFlag[] = []
	, outTypes: PropertyType[] = []
	): DILProperty[] => {
	return useMemo(() => {
		return filterProperties(selectedDefinitionName, flags, types, allowedProperties, outFlags, outTypes);
	}, [selectedDefinitionName, flags, types]);
};

function getPropertyListFromDil(DIL: DIL | string): DILPropertyList {
	DIL = (typeof DIL === "string") ? selectDilDefinitionByName(DIL) : DIL;
	return DIL.propertyList;
}